import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Credentials } from "../Common/Types/types";
import { RootState } from "../Core/Store";
import { AuthApi } from "./api";

interface authSliceState {
  auth: boolean;
  loadingState?: string;
  errorMessage?: string;
}
const initialAuth: boolean = false;
const initialState: authSliceState = {
  auth: initialAuth,
  loadingState: undefined,
  errorMessage: undefined,
};

export const loginTest = createAsyncThunk("auth/loginTest", async () => {
  const response = await AuthApi.loginTest();
  return response;
});
export const login = createAsyncThunk(
  "auth/login",
  async (creds: Credentials) => {
    const response = await AuthApi.login(creds);
    return response;
  }
);
export const logout = createAsyncThunk("auth/logout", async () => {
  const response = await AuthApi.logout();
  return response;
});
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loginTest.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        auth: action.payload,
      };
    });
    builder.addCase(loginTest.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "Please enter correct username and password",
      };
    });
    builder.addCase(loginTest.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
    builder.addCase(login.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        auth: action.payload,
      };
    });
    builder.addCase(login.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "Please enter correct username and password",
      };
    });
    builder.addCase(login.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
      builder.addCase(logout.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        auth: action.payload,
      };
    });
    builder.addCase(logout.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "error",
      };
    });
    builder.addCase(logout.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
  },
});
export const loginSelector = (state: RootState) => state.auth.auth;

export const loadingLoginSelector = (state: RootState) =>
  state.auth.loadingState;
export const errorLoginSelector = (state: RootState) => state.auth.errorMessage;
export default authSlice.reducer;
